export function PublicAuthenticationRoutes(
    $stateProvider,
    PAGE_LAYOUT,
    AuthenticationError,
    BASE_PATH_APP,
    BASE_PATH_PUBLIC
) {
    $stateProvider
        .state('authentication', {
            url: '/authentication',
            abstract: true,
            template: '<public-ajs-app-shell></public-ajs-app-shell>',
            data: {
                layout: PAGE_LAYOUT.NoNavigationFullWidth
            }
        })
        .state('authentication.two-factor-authentication-verification', {
            controller: 'TwoFactorAuthenticationVerificationController as vm',
            url: '/two-factor-authentication-verification?token&returnUrl&isMobileApplication',
            template: require('./pages/two-factor-authentication-verification.html'),
            resolve: {
                resourceStrings: ['ResourceStringsLoaderService', function getResourceStrings(ResourceStringsLoaderService) {
                    return ResourceStringsLoaderService.loadResourceStrings();
                }],
                deviceFingerprint: ['FingerprintingService', function getDeviceFingerprint(FingerprintingService) {
                    return FingerprintingService.getDeviceFingerprint();
                }],
                isDeviceBeingRemembered: ['PublicTwoFactorAuthenticationApi', '$stateParams', 'deviceFingerprint', '$q', '$window', 'RedirectToLoginService', function isDeviceBeingRemembered(PublicTwoFactorAuthenticationApi, $stateParams, deviceFingerprint, $q, $window, RedirectToLoginService) {
                    // We could not find the token so we do the same of the getConfiguration and redirect to login page
                    if (!$stateParams.token) {
                        RedirectToLoginService.redirect();
                    }

                    const deferred = $q.defer();

                    const request = {
                        token: $stateParams.token,
                        deviceFingerprint
                    };

                    PublicTwoFactorAuthenticationApi.validateRememberedDevice(request)
                        .then(result => {
                            if (result.IsSuccess) {
                                // If the device is being remembered we reject the promise and redirect the user
                                // to the appropriate location.
                                const returnUrl = ($stateParams.returnUrl || $stateParams.ReturnUrl) || `${BASE_PATH_APP}/homepage/dashboard`;
                                let redirectUrl = `${BASE_PATH_PUBLIC}/authentication/login-with-token?userToken=${result.Token}&returnUrl=${returnUrl}&is2FAVerified=true`;
                                if ($stateParams.isMobileApplication) {
                                    redirectUrl += `&isMobileApplication=${$stateParams.isMobileApplication}`;
                                }
                                $window.location.assign(redirectUrl);
                                deferred.reject();
                            } else {
                                deferred.resolve(result.IsSuccess);
                            }
                        })
                        .catch(error => {
                            if (error.status === 422 && error.data.ErrorCode === '202') {
                                const loginUrl = `${BASE_PATH_PUBLIC}/authentication/login?authError=${AuthenticationError.UnknownError}`;
                                $window.location.assign(loginUrl);
                            }
                            return null;
                        });

                    return deferred.promise;
                }],
                twoFactorAuthenticationConfiguration: ['PublicTwoFactorAuthenticationApi', '$stateParams', 'isDeviceBeingRemembered', '$window', 'RedirectToLoginService', function twoFactorAuthenticationConfiguration(PublicTwoFactorAuthenticationApi, $stateParams, isDeviceBeingRemembered, $window, RedirectToLoginService) {
                    // We only fetch the configuration if the device is not being remembered.
                    // After resolving isDeviceBeingRemembered, if it is not false we don't bother to get the configuration as it won't be needed.
                    // We can't check for true because when the promise is rejected we will get undefined for isDeviceBeingRemembered
                    // which means the device is being remembered.
                    // We only get a value of false when the promise is resolved.
                    if (isDeviceBeingRemembered !== false) {
                        return undefined;
                    }

                    return PublicTwoFactorAuthenticationApi.getConfiguration({token: $stateParams.token})
                        .catch(error => {
                            if (error.status === 422) {
                                if (error.data.errorCode === '211') {
                                    // In this case the user does not have a configuration. It doesn't
                                    // really matter what is returned because it will never be used.
                                    return undefined;
                                } else if (error.data.ErrorCode === '201') {
                                    // For some unknown reason the authentication is not valid anymore
                                    // we redirect the user to the login page
                                    RedirectToLoginService.redirect();
                                }
                            }

                            return null;
                        });
                }],
                isSmsVoiceServiceEnabled: ['PublicFeatureFlagsService', function isSmsVoiceServiceEnabled(PublicFeatureFlagsService) {
                    return PublicFeatureFlagsService.retrieveFlag(PublicFeatureFlagsService.keys.TwilioService);
                }],
                isSmsServiceEnabled: ['PublicFeatureFlagsService', function isSmsServiceEnabled(PublicFeatureFlagsService) {
                    return PublicFeatureFlagsService.retrieveFlag(PublicFeatureFlagsService.keys.TwilioSMSService);
                }],
                isVoiceServiceEnabled: ['PublicFeatureFlagsService', function isVoiceServiceEnabled(PublicFeatureFlagsService) {
                    return PublicFeatureFlagsService.retrieveFlag(PublicFeatureFlagsService.keys.TwilioVoiceService);
                }],
                isVerifyApiServiceEnabled: ['PublicFeatureFlagsService', function isVoiceServiceEnabled(PublicFeatureFlagsService) {
                    return PublicFeatureFlagsService.retrieveFlag(PublicFeatureFlagsService.keys.TwilioVerifyApiService);
                }],
                isTwilioServiceEnabled: ['PublicFeatureFlagsService', '$q', function isTwilioServiceEnabled(PublicFeatureFlagsService, $q) {
                    const flags = [
                        PublicFeatureFlagsService.retrieveFlag(PublicFeatureFlagsService.keys.TwilioSMSService),
                        PublicFeatureFlagsService.retrieveFlag(PublicFeatureFlagsService.keys.TwilioVoiceService),
                        PublicFeatureFlagsService.retrieveFlag(PublicFeatureFlagsService.keys.TwilioVerifyApiService),
                        PublicFeatureFlagsService.retrieveFlag(PublicFeatureFlagsService.keys.TwilioService)
                    ];
                    return $q.all(flags)
                        .then(([isSmsEnabled, isVoiceEnabled, isVerifyApiEnabled, isServiceEnabled]) => isSmsEnabled || isVoiceEnabled || isVerifyApiEnabled || isServiceEnabled);
                }]
            }
        })
        .state('authentication.login', {
            controller: 'LoginController as vm',
            url: '/login?returnUrl&authError&warnPassReset&existingTrial&ReturnUrl&sso',
            template: require('./pages/login/login.html'),
            data: {
                timePageLoad: true
            },
            resolve: {
                resourceStrings: ['ResourceStringsLoaderService', function getResourceStrings(ResourceStringsLoaderService) {
                    return ResourceStringsLoaderService.loadResourceStrings();
                }],
                loginSettings: ['PublicAuthenticationApi', function loginSettings(PublicAuthenticationApi) {
                    return PublicAuthenticationApi.getLoginSettings();
                }],
                isAuthServerEnabled: ['PublicFeatureFlagsService', function isAuthServerEnabled(PublicFeatureFlagsService) {
                    return PublicFeatureFlagsService.retrieveFlag(PublicFeatureFlagsService.keys.AuthServerForManagerApiService);
                }],
            }
        })
        .state('authentication.login-with-token', {
            controller: 'LoginWithTokenController as vm',
            url: '/login-with-token?userToken&provider&returnUrl&unitCount&ReturnUrl&is2FAVerified&isMobileApplication',
            resolve: {
                resourceStrings: ['ResourceStringsLoaderService', function getResourceStrings(ResourceStringsLoaderService) {
                    return ResourceStringsLoaderService.loadResourceStrings();
                }],
                loginWithTokenResult: ['PublicAuthenticationApi', '$stateParams', 'Notify', function loginWithToken(PublicAuthenticationApi, $stateParams, Notify) {
                    const ref = document.referrer;
                    let request = {
                        SignInToken: $stateParams.userToken,
                        ThirdPartyProvider: $stateParams.provider,
                        ReturnUrl: $stateParams.returnUrl || $stateParams.ReturnUrl,
                        UnitCount: $stateParams.unitCount,
                        ReferrerPage: ref.indexOf('?') !== -1 ? ref.slice(0, ref.indexOf('?')) : ref,
                        Is2FAVerified: $stateParams.is2FAVerified ?? false
                    };

                    if ($stateParams.isMobileApplication) {
                        request = Object.assign(request, {'isMobileApplication': $stateParams.isMobileApplication});
                    }

                    return PublicAuthenticationApi.loginWithToken(request)
                        .then(result => {
                            return {
                                success: true,
                                data: result
                            };
                        })
                        .catch(error => {
                            if (error.status === 422 || error.status === 401) {
                                return {
                                    success: false,
                                    errorCode: parseInt(error.data.ErrorCode, 10),
                                    errorMessage: error.data.UserMessage
                                };
                            }

                            Notify.error(error.data.UserMessage);

                            return null;
                        });
                }]
            }
        })
        .state('authentication.choose-subscriber', {
            controller: 'ChooseSubscriberController as vm',
            url: '/choose-subscriber?returnUrl&token&provider',
            template: require('./pages/choose-subscriber/choose-subscriber.html'),
            resolve: {
                resourceStrings: ['ResourceStringsLoaderService', function getResourceStrings(ResourceStringsLoaderService) {
                    return ResourceStringsLoaderService.loadResourceStrings();
                }],
                subscribersToChoose: ['Notify', 'PublicAuthenticationApi', '$stateParams', function lookupSubscribersToChoose(Notify, PublicAuthenticationApi, $stateParams) {
                    const request = {
                        token: $stateParams.token,
                        provider: $stateParams.provider
                    };

                    return PublicAuthenticationApi.lookupUserLoginsFromEmailAddress(request)
                        .then(result => {
                            return {
                                success: true,
                                data: result
                            };
                        })
                        .catch(error => {
                            if (error.status === 422) {
                                return {
                                    success: false,
                                    errorCode: parseInt(error.data.ErrorCode, 10),
                                    errorMessage: error.data.UserMessage
                                };
                            }

                            Notify.error(error.data.UserMessage);

                            return null;
                        });
                }]
            }
        })
        .state('authentication.admin-access-level-prompt', {
            controller: 'AdminAccessLevelPromptController as vm',
            url: '/admin-access-level-prompt?jwt',
            template: require('./pages/admin-access-level-prompt/admin-access-level-prompt.html'),
            resolve: {
                resourceStrings: ['ResourceStringsLoaderService', function getResourceStrings(ResourceStringsLoaderService) {
                    return ResourceStringsLoaderService.loadResourceStrings();
                }]
            }
        });
}

PublicAuthenticationRoutes.$inject = [
    '$stateProvider',
    'PAGE_LAYOUT',
    'AuthenticationError',
    'BASE_PATH_APP',
    'BASE_PATH_PUBLIC'
];
